import CodeMirror from 'codemirror/lib/codemirror.js';
/* import 'codemirror/mode/markdown/markdown.js'; */
import 'codemirror/mode/gfm/gfm.js';  /* text/x-gfm */
import 'codemirror/addon/mode/overlay.js';
import 'codemirror/addon/mode/simple.js';

// This simpler version can't handle quoted text
CodeMirror.defineSimpleMode('peml-simple', {
    start: [
        {
            token: 'builtin',
            regex: /:(endskip|ignore|skip|end|include)/,
        },
        {
            token: 'comment',
            regex: /\s*#.*$/,
        },
        {
            regex: /(\s*)([^\s:\.]+[^\s:]*\s*:)(\s*)/,
            token: [null, 'keyword', null],
            sol: true,
            push: 'value'
        },
        {
            regex: /(\s*)(\[[^\s\[\]]*\])(\s*)/,
            token: [null, 'keyword', null],
            sol: true,
        },
        {
            regex: /(\s*)(\{[^\s\[\]]*\})(\s*)/,
            token: [null, 'keyword', null],
            sol: true,
        },
        {
            regex: /\s*\*\s*/,
            token: 'keyword',
            sol: true
        },
    ],
    value: [
        {
            regex: /(?<delim>(?<char>\S)(\k<char>){2,})(\s*$)/,
            token: 'string',
            pop: true,
        },
        {
            regex: /(?=.)/,
            pop: true,
        },

    ]
});


// define mustache notation nested in github-style markdown
CodeMirror.defineMode("mustache", function(config, parserConfig) {
    var mustacheOverlay = {
        token: function(stream, state) {
            var ch;
            if (stream.match("{{"))
            {
                while ((ch = stream.next()) != null)
                {
                    if (ch == "}" && stream.next() == "}")
                    {
                        stream.eat("}");
                        return "variable-3";
                    }
                }
            }
            while (stream.next() != null && !stream.match("{{", false)) {}
            return null;
        }
    };
    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop || "text/x-gfm"), mustacheOverlay);
});


CodeMirror.defineMode("peml", function(config, parserConfig)
{
    var NORMAL = 0,
        VALUESTART = 1,
        INSTRING = 2,
        BEFOREURL = 3,
        INURL = 4,
        AFTERURL = 5;
    var pemlOverlay = {
        startState: function() {
            return {
                state: NORMAL,
                delimiter: null,
            };
        },
        token: function(stream, state) {
            // If a string starts here
            if (state.state == VALUESTART)
            {
                if (stream.match(/((?<delim>(?<char>\S)(\k<char>){2,}))/))
                {
                    state.delimiter = stream.current();
                    state.state = INSTRING;
                    return 'string';
                }
                state.state = BEFOREURL;
            }
            if (state.state == BEFOREURL)
            {
                if (stream.eatSpace())
                {
                    return null;
                }
                if (stream.match(/url\s*\(/))
                {
                    state.state = INURL;
                    return 'builtin';
                }
                state.state = NORMAL;
            }
            else if (state.state == INURL)
            {
                if (stream.match(/.*(?=\s*\))/))
                {
                    state.state = AFTERURL;
                    return 'link';
                }
                state.state = NORMAL;
            }
            else if (state.state == AFTERURL)
            {
                if (stream.eatSpace())
                {
                    return null;
                }
                else if (stream.match(/\)/))
                {
                    state.state = NORMAL;
                    return 'builtin';
                }
                state.state = NORMAL;
            }
            else if (stream.sol())
            {
                if (state.state == INSTRING)
                {
                    if (stream.match(state.delimiter))
                    {
                        state.state = NORMAL;
                        return 'string';
                    }
                }
                else if (stream.match(/^\s*#/))
                {
                    stream.skipToEnd();
                    return 'comment';
                }
                else if (stream.match(/^:(endskip|ignore|skip|end)\b/))
                {
                    return 'builtin';
                }
                else if (stream.match(/^:include\b/))
                {
                    state.state = BEFOREURL;
                    return 'builtin';
                }
                else if (stream.match(/^\s*[^\s:\.]+[^\s:]*\s*:/))
                {
                    state.state = VALUESTART;
                    return 'keyword';
                }
                else if (stream.match(/^\s\*/))
                {
                    return 'keyword';
                }
                else if (stream.match(/^\s*\[[^\s\[\]]*\]/)
                    || stream.match(/^\s*(\{[^\s\[\]]*\})/))
                {
                    return 'tag';
                }
            }

            if (stream.match("{{"))
            {
                var ch;
                while ((ch = stream.next()) != null)
                {
                    if (ch == "}" && stream.next() == "}")
                    {
                        stream.eat("}");
                        return "variable-3";
                    }
                }
            }
            while (stream.next() != null && !stream.match("{{", false)) {}
            return null;
        }
    };
    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop || "text/x-gfm"), pemlOverlay);
});

CodeMirror.defineMIME("text/peml", "peml");
CodeMirror.defineMIME("text/x-peml", "peml");
